import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";
import { DetailPageLayout } from "../components";

const mapStateToProps = ({ language, t, posts, highlightshowPage }) => {
  const data = _.get(posts, "data");
  const highlights = _.filter(data, item => {
    const categoryID = _.get(item, "category.id");
    return categoryID === _.toNumber(process.env.REACT_APP_POST_HIGHLIGHT_ID);
  });
  return {
    language,
    t,
    highlights,
    highlightshowPage: _.get(highlightshowPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class NewsDetail extends Component {
  render() {
    const id = this.props.match.params.id;
    const { highlights, highlightshowPage } = this.props;
    const video = _.get(highlightshowPage, "video");
    const imageBanner = _.get(highlightshowPage, "imageBanner");
    const imageBannerMobile = _.get(highlightshowPage, "imageBannerMobile");
    return (
      <DetailPageLayout
        data={highlights}
        id={_.toInteger(id)}
        path="highlight-detail"
        pageName="HIGHLIGHTS OF SHOW"
        page="highlights"
        media={video}
        imageBanner={imageBanner}
        imageBannerMobile={imageBannerMobile}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/HighlightDetail.js